export enum TipoDocCondominio {
    CONDOMINIO_MENSAL = 'C',
    CONDOMINIO_MENSAL_AGRUPADO = 'G',
    CHAMADA_EXTRA = 'E',
    PARCELA_DE_ACORDO = 'X'
}
export enum TipoDocAluguel {
    ALUGUEL_MENSAL = 'A',
    MES_DA_RESCISAO = 'RS',
    PARCELA_DE_ACORDO = 'X'
}


export enum Sistema {
    CONDOMINIO = 'C',
    ALUGUEL = 'A'
}

export enum Empresa {
    VILA_RICA = 1,
    SAO_LUIZ = 2,
    EASY_MONEY = 3
}

export type Endereco = {
    uf: string
    cidade: string
    bairro: string
    rua: string
    numero: string
    complemento: string
    cep: string
    enderecoCompleto: string
}

export type Assessor = {
    codigo: number
    nome: string
    username: string
    ativo: boolean
}

export type Filial = {
    codigo: number
    descricao: string
    abrev: string
    empresa: Empresa
}

export type Condominio = {
    codigo: number
    abrev: string
    nome: string
    assessor: Assessor
    filial: Filial
    endereco: Endereco
}

export type Unidade = {
    codigo: number
    descricao: string
    condominio: Condominio
}

export type Imovel = {
    codigo: number
    subcodigo: number
    filial: Filial
    endereco: Endereco
}

export type BoletoCommon = {
    codigo: number
    nome: string
    tipoDOCAgrupado: string
    unidadeAgrupada: string
    competencia: string
    dataVencimento: string
    atualizarVencimento: boolean
    valor: number
    valorJMC: number
    valorAtualizado: number
}

export type BoletoCondominio = {
    sistema: Sistema.CONDOMINIO
    tipoDOC: TipoDocCondominio
    unidade: Unidade
} & BoletoCommon

export type BoletoAluguel = {
    sistema: Sistema.ALUGUEL
    tipoDOC: TipoDocAluguel
    imovel: Imovel
} & BoletoCommon



export type Boleto =
    BoletoCondominio
    |
    BoletoAluguel
